module.exports = __webpack_public_path__ + "img/16_125.c9873355.png";